import { render, staticRenderFns } from "./administrationFormCreatorReportSubmissionDetails.vue?vue&type=template&id=51a9534e&"
import script from "./administrationFormCreatorReportSubmissionDetails.vue?vue&type=script&lang=js&"
export * from "./administrationFormCreatorReportSubmissionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports